module.exports = __webpack_public_path__ + "static/troll.b107f176.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/troll.png
// module id = 452
// module chunks = 168707334958949